import React, { useState } from 'react'
import PropTypes from 'prop-types'
import strings from 'utils/strings'
import {
  CardContainer,
  CardColumn,
  CardLabel,
  CardLabelText,
  CardLabelIconWrap,
  VersionCard,
  RadioInput,
  RadioWrap,
  CardContent,
  CardTitleRow,
  FeatureStatus,
  HelperText,
  WhyNotButton,
  WhyNotContent,
} from './FeatureVersionUpdateModal.style'

const FeatureVersionCard = ({
  currentFeature,
  updatedFeature,
  selection,
  onSelect,
  serialNumber,
}) => {
  const [whyNotExpanded, setWhyNotExpanded] = useState(false)

  const isIncompatible = updatedFeature && updatedFeature.isCompatible === false
  const noReplacementAvailable = !updatedFeature
  const isUpdateDisabled = isIncompatible || noReplacementAvailable

  const isCurrentObsolete =
    currentFeature.status && currentFeature.status.toLowerCase() === 'obsolete'

  const currentHelperText = isCurrentObsolete
    ? 'This Feature is Obsolete. You may want to replace it. If replaced, this Feature cannot be returned to the vehicle.'
    : 'This is not the most recent version of this Feature.'

  const updatedHelperText =
    updatedFeature && !isIncompatible
      ? updatedFeature.isRevisionUpdate
        ? 'This Feature has been revised. You may want to use this version.'
        : 'This Feature has been updated. You may want to test this version on your vehicle.'
      : null

  return (
    <CardContainer>
      {/* Version on the vehicle */}
      <CardColumn>
        <CardLabel>
          <CardLabelIconWrap>
            <svg
              width="22"
              height="16"
              viewBox="0 0 22 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              alt="truck"
              style={{ width: 22, height: 'auto', objectFit: 'contain' }}
            >
              <g clip-path="url(#clip0_4214_73680)">
                <path
                  d="M16.0216 9.45043C15.3916 9.45043 14.7816 9.64043 14.2616 10.0004C13.7416 10.3604 13.3316 10.8704 13.0916 11.4704C12.8516 12.0704 12.7916 12.7304 12.9116 13.3604C13.0316 14.0004 13.3316 14.5804 13.7816 15.0404C14.2216 15.5004 14.7916 15.8104 15.4116 15.9404C16.0316 16.0704 16.6616 16.0004 17.2416 15.7504C17.8216 15.5004 18.3216 15.0804 18.6616 14.5404C19.0116 14.0004 19.1916 13.3704 19.1916 12.7204C19.1916 11.8504 18.8616 11.0204 18.2616 10.4004C17.6616 9.79043 16.8616 9.44043 16.0216 9.44043V9.45043ZM16.0216 14.5404C15.6716 14.5404 15.3316 14.4304 15.0416 14.2304C14.7516 14.0304 14.5216 13.7504 14.3916 13.4104C14.2616 13.0804 14.2216 12.7104 14.2916 12.3604C14.3616 12.0104 14.5316 11.6804 14.7716 11.4304C15.0216 11.1804 15.3316 11.0004 15.6716 10.9304C16.0116 10.8604 16.3716 10.9004 16.6916 11.0304C17.0116 11.1704 17.2916 11.4004 17.4816 11.7004C17.6716 12.0004 17.7816 12.3504 17.7816 12.7104C17.7816 13.1904 17.5916 13.6604 17.2616 14.0004C16.9316 14.3404 16.4816 14.5304 16.0116 14.5304L16.0216 14.5404Z"
                  fill="#4F5764"
                  fill-opacity="0.87"
                />
                <path
                  d="M21.73 6.93L15.17 5.16C15.07 5.13 14.99 5.07 14.94 4.98L12.3 0.19C12.24 0.07 12.11 0 11.98 0H5.76C5.56 0 5.39 0.16 5.39 0.36V10.63H0.63C0.28 10.63 0 10.91 0 11.25V11.83C0 12.17 0.28 12.45 0.63 12.45H12.07C12.1 12.03 12.19 11.61 12.35 11.22C12.64 10.5 13.14 9.89 13.77 9.46C14.4 9.03 15.15 8.8 15.91 8.8C16.93 8.8 17.92 9.21 18.64 9.95C19.33 10.65 19.73 11.59 19.77 12.57H21.63C21.83 12.57 22 12.41 22 12.21V7.28C22 7.12 21.89 6.97 21.73 6.93ZM13.44 5.15H8.77C8.57 5.15 8.4 4.99 8.4 4.79V1.22C8.4 1.02 8.56 0.86 8.77 0.86H11.41C11.54 0.86 11.67 0.93 11.73 1.05L13.75 4.62C13.89 4.86 13.71 5.16 13.43 5.16L13.44 5.15Z"
                  fill="#4F5764"
                  fill-opacity="0.87"
                />
              </g>
              <defs>
                <clipPath id="clip0_4214_73680">
                  <rect width="22" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </CardLabelIconWrap>
          <CardLabelText>Version On The Vehicle</CardLabelText>
        </CardLabel>
        <VersionCard
          isSelected={selection === 'keep'}
          onClick={() => onSelect('keep')}
        >
          <RadioInput
            type="radio"
            name={`feature-${currentFeature.id}`}
            checked={selection === 'keep'}
            onChange={() => onSelect('keep')}
          />
          <CardContent>
            <CardTitleRow>
              <span>{currentFeature.partNumber}</span>
              <span
                style={{ width: '130px', textAlign: 'right', flexShrink: 0 }}
              >
                Revision: {currentFeature.revision || '-'}
              </span>
            </CardTitleRow>
            <FeatureStatus>
              <strong>Feature Status: </strong>
              {currentFeature.status}
            </FeatureStatus>
            {currentHelperText && <HelperText>{currentHelperText}</HelperText>}
          </CardContent>
        </VersionCard>
      </CardColumn>

      {/* Updated version */}
      <CardColumn>
        <CardLabel>
          <CardLabelIconWrap>
            {isUpdateDisabled ? (
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M15.298 6.304L9.696.702A2.4 2.4 0 0 0 8 0a2.4 2.4 0 0 0-1.696.702L.702 6.304A2.4 2.4 0 0 0 0 8c0 .636.253 1.246.702 1.696l5.602 5.602A2.4 2.4 0 0 0 8 16a2.4 2.4 0 0 0 1.696-.702l5.602-5.602A2.4 2.4 0 0 0 16 8a2.4 2.4 0 0 0-.702-1.696ZM11.165 10.422c0-.207-.083-.406-.23-.552L9.11 7.995l1.864-1.86a.78.78 0 0 0 0-1.105.78.78 0 0 0-1.108 0L7.864 7.035 8.011 6.89l-1.864-1.86a.783.783 0 0 0-1.107.012.783.783 0 0 0 .001 1.116L6.903 8.018l-1.864 1.852a.78.78 0 0 0 0 1.104.78.78 0 0 0 1.108 0l1.825-1.86 1.856 1.86a.78.78 0 0 0 1.107 0 .78.78 0 0 0 .23-.552Z"
                  fill="#4F5764"
                  fillOpacity="0.87"
                />
              </svg>
            ) : (
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ transform: 'scaleX(-1)' }}
              >
                <path
                  d="M9.015.067C7.255-.161 5.469.198 3.933 1.087A7.112 7.112 0 0 0 1.778 2.9V1.766a.889.889 0 1 0-1.778 0v3.562c0 .491.398.889.889.889h.428l.033-.001h3.094a.889.889 0 0 0 0-1.778H2.835a5.34 5.34 0 0 1 1.988-1.814 5.334 5.334 0 0 1 3.964-.796 5.334 5.334 0 0 1 3.633 1.778 5.334 5.334 0 0 1 1.81 3.624.889.889 0 1 0 1.761-.243A7.112 7.112 0 0 0 13.672 2.346 7.112 7.112 0 0 0 9.015.067Z"
                  fill="#4F5764"
                  fillOpacity="0.87"
                />
                <path
                  d="M1.77 8.768a.889.889 0 0 0-1.761.243 7.112 7.112 0 0 0 2.319 4.643 7.112 7.112 0 0 0 4.657 2.28 7.112 7.112 0 0 0 5.082-1.021 7.112 7.112 0 0 0 2.155-1.813v1.134a.889.889 0 1 0 1.778 0v-3.562a.889.889 0 0 0-.889-.889h-.428l-.033.001h-3.094a.889.889 0 0 0 0 1.778h1.61a5.334 5.334 0 0 1-1.99 1.814 5.334 5.334 0 0 1-3.963.796 5.334 5.334 0 0 1-3.633-1.778 5.334 5.334 0 0 1-1.81-3.624Z"
                  fill="#4F5764"
                  fillOpacity="0.87"
                />
              </svg>
            )}
          </CardLabelIconWrap>
          <CardLabelText>Updated Version</CardLabelText>
        </CardLabel>
        <VersionCard
          isSelected={selection === 'update'}
          disabled={isUpdateDisabled}
          onClick={() => !isUpdateDisabled && onSelect('update')}
        >
          <RadioWrap disabled={isUpdateDisabled}>
            <RadioInput
              type="radio"
              name={`feature-${currentFeature.id}`}
              checked={selection === 'update'}
              disabled={isUpdateDisabled}
              onChange={() => !isUpdateDisabled && onSelect('update')}
            />
          </RadioWrap>
          <CardContent>
            <CardTitleRow>
              <span>
                {updatedFeature
                  ? updatedFeature.partNumber
                  : currentFeature.partNumber}
              </span>
              <span
                style={{ width: '130px', textAlign: 'right', flexShrink: 0 }}
              >
                Revision:{' '}
                {updatedFeature ? updatedFeature.revision || '-' : '-'}
              </span>
            </CardTitleRow>
            <FeatureStatus>
              <strong>Feature Status: </strong>
              {updatedFeature ? updatedFeature.status : 'N/A'}
            </FeatureStatus>
            {isUpdateDisabled && !noReplacementAvailable && (
              <>
                <HelperText>{strings.version_cannot_be_added}</HelperText>
                <WhyNotButton
                  onClick={(e) => {
                    e.stopPropagation()
                    setWhyNotExpanded(!whyNotExpanded)
                  }}
                >
                  {strings.why_not}
                  <svg
                    width="10"
                    height="5"
                    viewBox="0 0 10 5"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{
                      transform: whyNotExpanded
                        ? 'rotate(180deg)'
                        : 'rotate(0deg)',
                      flexShrink: 0,
                    }}
                  >
                    <path d="M0 0L5 5L10 0H0Z" fill="#0b2e6b" />
                  </svg>
                </WhyNotButton>
                {whyNotExpanded && (
                  <WhyNotContent>
                    {updatedFeature.incompatibilityReason?.length > 0 &&
                      updatedFeature.incompatibilityReason.map((r) => (
                        <p key={r}>{r}</p>
                      ))}
                    {updatedFeature.resourceLimitData && (
                      <>
                        <p>
                          CHEC cannot update to the newer version of this
                          Feature because it would exceed the maximum of{' '}
                          {updatedFeature.resourceLimitData.exceededResources.map(
                            (res, i, arr) => (
                              <span key={res.label}>
                                <strong>{res.max}</strong> {res.label}
                                {i < arr.length - 1 ? ' and ' : ''}
                              </span>
                            )
                          )}{' '}
                          allowed on the ECU.
                        </p>
                        <p>&nbsp;</p>
                        <ul>
                          {updatedFeature.resourceLimitData.currentTotals.map(
                            (t) => (
                              <li key={t.label}>
                                There are <strong>{t.count}</strong> {t.label}{' '}
                                on {t.module}
                              </li>
                            )
                          )}
                        </ul>
                        <p>&nbsp;</p>
                        <p>
                          To commit your changes to {serialNumber}, go back and
                          remove:
                        </p>
                        <p>&nbsp;</p>
                        <ul>
                          {updatedFeature.resourceLimitData.removals.map(
                            (r) => (
                              <li key={r.label}>
                                <strong>{r.count}</strong> {r.label} from{' '}
                                {r.module}
                              </li>
                            )
                          )}
                        </ul>
                        <p>&nbsp;</p>
                        <p>This will require removing or editing Features.</p>
                      </>
                    )}
                    {!updatedFeature.resourceLimitData &&
                      (!updatedFeature.incompatibilityReason ||
                        updatedFeature.incompatibilityReason.length === 0) && (
                        <p>{strings.version_cannot_be_added}</p>
                      )}
                  </WhyNotContent>
                )}
              </>
            )}
            {noReplacementAvailable && (
              <HelperText>{strings.no_replacement_available}</HelperText>
            )}
            {!isUpdateDisabled && updatedHelperText && (
              <HelperText>{updatedHelperText}</HelperText>
            )}
          </CardContent>
        </VersionCard>
      </CardColumn>
    </CardContainer>
  )
}

FeatureVersionCard.propTypes = {
  currentFeature: PropTypes.object.isRequired,
  updatedFeature: PropTypes.object,
  selection: PropTypes.oneOf(['keep', 'update', null]),
  onSelect: PropTypes.func.isRequired,
  serialNumber: PropTypes.string,
}

export default FeatureVersionCard
